import React, { useEffect } from "react";
import Header from "../Layout/Header";
import {
  Box,
  CircularProgress,
  Container,
  Grid,
  Typography,
  TextField,
  IconButton,
} from "@material-ui/core";

import Footer from "../Layout/Footer";
import { gpColors } from "../../constants/colors";
import { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Pagination } from "@material-ui/lab";
import usePagination from "./Pegination";
import oilfilter from "../../Images/oilFilter-banner.jpg";
import SearchOutlined from "@material-ui/icons/SearchOutlined";
import { Helmet } from "react-helmet";
import _ from "lodash";

const useStyles = makeStyles((theme) => ({
  container: {
    width: "100%",
    padding: "30px",
    position: "relative",
    marginTop: "75px",
    [theme.breakpoints.up("sm")]: {
      marginTop: "105px",
    },
  },
  filterHeader: {
    fontWeight: 900,
    fontSize: "20px",
    height: "53px",
    background: "#36404b",
    margin: "0px",
    lineHeight: "58px",
    letterSpacing: "1px",
    textAlign: "center",
    color: "#fff",
    position: "relative",
    width: "260px",
    marginBottom: "30px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "&:before": {
      content: "''",
      left: "-20px",
      borderStyle: "solid",
      borderWidth: "0 0 53px 20px",
      borderColor: `transparent transparent ${gpColors.logoBrown} transparent`,
      position: "absolute",
    },
    "&:after": {
      content: "''",
      right: "-20px",
      borderStyle: "solid",
      borderWidth: "53px 20px 0 0",
      borderColor: `${gpColors.logoBrown} transparent transparent transparent`,
      position: "absolute",
    },
  },
  gridList: {
    borderBottom: "1px solid #ddd",
    paddingLeft: "10px",
    paddingRight: "5px",
    direction: "column",
    display: "flex",
    alignItems: "center",
  },
  img: {
    height: "100%",
    width: "65%",
    [theme.breakpoints.only("sm")]: {
      width: "30%",
    },
  },
  gridWrapper: {
    height: 195,
    width: "80%",
    borderLeft: "1px solid #ddd",
    borderRight: "1px solid #ddd",
    borderTop: "1px solid #ddd",
    //mobile view
    [theme.breakpoints.only("sm")]: {
      width: "100%",
      height: 230,
    },
    [theme.breakpoints.only("xs")]: {
      width: "100%",
      height: 230,
    },
  },
  filterContent: {
    fontSize: "16px",
    lineHeight: 2,
    textAlign: "justify",
    marginLeft: "50px",
    marginRight: "50px",
    [theme.breakpoints.down("md")]: {
      marginLeft: "0px",
      marginRight: "0px",
    },
  },
  imgBox: {
    width: "30%",
    height: 195,
    //mobile view
    [theme.breakpoints.only("xs")]: {
      width: "100%",
      display: "flex",
      justifyContent: "center",
      height: "100%",
    },
    // ipad view
    [theme.breakpoints.only("sm")]: {
      width: "100%",
      display: "flex",
      justifyContent: "center",
      height: "100%",
    },
  },
  elementContainer: {
    width: "100%",
    marginBottom: "10px",
    //mobile view
    [theme.breakpoints.up("sm")]: {
      display: "block",
    },
    //desktop view
    [theme.breakpoints.up("md")]: {
      display: "flex",
    },
  },
  changeRowColor: {
    // backgroundColor: "#ebecf0",
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
  loaderContainer: {
    textAlign: "center",
    color: "#BE0A00",
    alignItems: "center",
    backgroundColor: "",
    display: "flex",
    justifyContent: "center",
    height: "20vh",
  },
}));
const OilFilter = () => {
  const classes = useStyles();

  const [apiData, setApiData] = useState([])
  const [oilFilterData, setOilFilterData] = useState([]);
  const [loader, setLoader] = useState(false);

  const [FilterKey, setFilterKey] = useState('')
  const [showMsg, setMsg] = useState()

  useEffect(() => {
    // console.log("rendered");
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });

    getOilFilterDetails();

  }, []);
  // console.log(oilFilterData);

  const getOilFilterDetails = async () => {
    setLoader(true);
    try {
      const resp = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/getProducts/${1}`,
        {
          method: "GET",
          headers: {
            // // "ngrok-skip-browser-warning": "true",
          },
        }
      );
      const data = await resp.json();
      setApiData(data)
      setOilFilterData(data)

      setLoader(false);
    } catch (e) {
      console.log(e);
      setLoader(false);
    }
  };
  // for pegination set pegination count and data
  let [page, setPage] = useState(1);
  const PER_PAGE = 10;

  const count = Math.ceil(oilFilterData.length / PER_PAGE);
  let _DATA = usePagination(oilFilterData, PER_PAGE);
  // console.log("_DATA", _DATA.currentData());

  const handleChange = (e, p) => {
    setPage(p);
    _DATA.jump(p);
  };

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        {/* <title>My Title</title> */}
        <meta name="keywords" content="Oil filter manufacturer, Best Oil Filters"/>
        <meta
          name="description"
          content="Experience exceptional oil filtration with our automotive oil filters. Engineered for maximum efficiency and durability, our oil filters protect your engine from harmful contaminants. Trust our ISO-certified manufacturing and stringent quality control to keep your engine running smoothly. Explore our oil filter range now."
        />
      </Helmet>
      <Header />

      <Container>
        <div className={classes.container}>
          <div>
            <div
              style={{
                textAlign: "center",
                display: "flex",
                justifyContent: "center",
              }}
            >
              {/* <div className={classes.filterHeader}>Oil Filter</div> */}
               <div
                style={{
                  width: "100%",
                  height: "10%",
                  backgroundColor: "black",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                {/*<img
                  src={oilfilter}
                  style={{ width: "100%",objectFit: "cover" }}
                />*/}
              </div> 
            </div>

            <div className={classes.filterContent}>
              <p>
                {" "}
                Discover the leading oil filter manufacturer providing
                high-quality filtration solutions for automotive and industrial
                applications. Our state-of-the-art manufacturing facilities and
                advanced engineering expertise ensure superior performance,
                efficiency, and reliability in every oil filter we produce. With
                a commitment to innovation and precision, we offer a
                comprehensive range of oil filters designed to meet the demands
                of modern engines and machinery. Trust in our industry-leading
                expertise and experience to keep your engines clean, protect
                vital components, and enhance overall performance.
              </p>
              <p>
                {" "}
                Choose our oil filters for unmatched quality, durability, and
                peace of mind. With a wide quality range of raw material
                sources, we can make filters to clients’ needs from economy
                lines to premium lines at competitive prices. With a wide range
                of sizes and specifications available, we have the perfect oil
                filter for your vehicle.
              </p>
            </div>
            <div
              style={{
                width: "100%",
                alignItems: "center",
                justifyContent: "center",
                display: "flex",
              }}
            >
              {/* {
                "part_no": "HO51748XD",
              "application": "Autocar, Cummins, Ford, Freightliner, Hitachi, Kenworth, Komatsu, Peterbilt, Samsung, White Trucks",
              "image_name": "HO51748XD.PNG",
              "brand_no": "BD7309,51748XD",
              "brand": "BALDWIN,WIX"
              }, */}

              <TextField
                fullWidth
                id="standard-bare"
                variant="outlined"
                label="Oil Filter"
                onChange={(e) => {
                  setFilterKey(e.target.value);
                  // var a = apiData.filter((item, id) => (((item.part_no).toLowerCase()).includes(e.target.value.toLowerCase())))
                
                  var a = apiData.filter((item, id) => (((item.part_no).toLowerCase()).includes(e.target.value.toLowerCase()) || ((item.brand_no.replace(',',' ')).toLowerCase()).includes(e.target.value.toLowerCase())))

                  // let k
                  // apiData.map((item, id) => {
                  //   if(((item.part_no).toLowerCase()).includes(e.target.value.toLowerCase())){
                  //     console.log('item is',[item])
                  //     k.push(item)
                  //   }
                  //   else if(((item.brand_no.replace(',',' ')).toLowerCase()).includes(e.target.value.toLowerCase())){
                  //     k=[...item]
                  //   }
                  //   else{
                  //     k=[]
                  //   }
                  // })
                  setOilFilterData(apiData)
                  // _DATA=apiData
                  setPage(1)
                  _DATA.jump(1)
                  if (e.target.value == '') {
                    setOilFilterData(apiData)
                    // _DATA=[apiData]
                  }
                  if (e.target.value != '' && a.length > 0) {
                    setOilFilterData(a)
                    // _DATA=[a]
                    // _DATA.jump(1)
                    // setPage(1)
                  }

                  else if (a.length <= 0) {
                    setOilFilterData([])
                    // _DATA=[]
                    // setPage(1)
                    // _DATA.jump(1);
                  }

                }}
                InputProps={{
                  endAdornment: (
                    <IconButton
                    //   onClick={(e) =>
                    //     {console.log('filtered key',FilterKey);
                    //   console.log(oilFilterData.length)
                    //   if(FilterKey==''){
                    //     setOilFilterData(apiData)
                    //   }
                    //   else{
                    //   var a=apiData.filter((item,id)=>(((item.part_no).toLowerCase()).includes(FilterKey.toLowerCase())))
                    //   var b=oilFilterData.filter((item,id)=>(!(((item.part_no).toLowerCase()).includes(FilterKey.toLowerCase()))))
                    //   // var a=oilFilterData.filter((item,id)=>(item.part_no).toLowerCase()==FilterKey.toLowerCase())
                    //   // var b=oilFilterData.filter((item,id)=>(item.part_no).toLowerCase()!=FilterKey.toLowerCase())
                    //   setOilFilterData(a)
                    //   setPage(1)
                    //   _DATA.jump(1)
                    //   }

                    // }}
                    >
                      <SearchOutlined />
                    </IconButton>
                  ),
                }}
              />
            </div>

            <Container maxWidth="md">
              <Box marginTop={5}>
                {loader === true && (
                  <Box className={classes.loaderContainer}>
                    <CircularProgress color="inherit" />
                  </Box>
                )}

                {loader === false && oilFilterData.length === 0 && (
                  <Typography style={{ textAlign: "center" }}>
                    NO DATA AVAILABLE
                  </Typography>
                )}
                {loader === false && _DATA.currentData().length !== 0 && (
                  // console.log('_DATA.currentData()',_DATA.currentData()),
                  <>
                    {_DATA.currentData().map((value, index) => {
                      var brand;
                      var brandNo;
                      if (value.brand !== null) {
                        brand = value.brand.split(",");
                      }
                      if (value.brand_no !== null) {
                        brandNo = value.brand_no.split(",");
                      }
                      return (
                        <Box className={classes.elementContainer} key={index}>
                          <Box className={classes.imgBox}>
                            <img
                              // src={value.image_name}
                              src={`${process.env.REACT_APP_IMAGE_URL}/${value.image_name}`}
                              className={classes.img}
                              alt={value.part_no}
                              loading="lazy"
                            />
                          </Box>
                          <Grid container className={classes.gridWrapper}>
                            <Grid container className={classes.changeRowColor}>
                              <Grid
                                item
                                container
                                xs={4}
                                className={classes.gridList}
                                style={{ borderRight: "1px solid #ddd" }}
                              >
                                GPA#
                              </Grid>
                              <Grid
                                item
                                container
                                xs={8}
                                className={classes.gridList}
                              >
                                <b>{value.part_no}</b>
                              </Grid>
                            </Grid>
                            {brand.map((element, position) => (
                              <Grid
                                container
                                key={position}
                                className={classes.changeRowColor}
                              >
                                <Grid
                                  item
                                  container
                                  xs={4}
                                  className={classes.gridList}
                                  style={{ borderRight: "1px solid #ddd" }}
                                >
                                  {element}
                                </Grid>
                                <Grid
                                  item
                                  container
                                  xs={8}
                                  className={classes.gridList}
                                >
                                  {brandNo[position]}
                                </Grid>
                              </Grid>
                            ))}
                            <Grid container className={classes.changeRowColor}>
                              <Grid
                                item
                                container
                                xs={4}
                                className={classes.gridList}
                                style={{ borderRight: "1px solid #ddd" }}
                              >
                                APPLICATION
                              </Grid>
                              <Grid
                                item
                                container
                                xs={8}
                                className={classes.gridList}
                              >
                                {value.application}
                              </Grid>
                            </Grid>
                          </Grid>
                        </Box>
                      );
                    })}

                    <Box display="flex" justifyContent="center">
                      <Pagination
                        count={count}
                        page={page}
                        onChange={handleChange}
                      />
                    </Box>
                  </>
                )}
              </Box>
            </Container>
          </div>
        </div>
      </Container>
      <Footer />
    </>
  );
};
export default OilFilter;
